import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {homePageFactory} from './home-page.factory';

import PALETTE_SCHEMA from './home.page.palette-schema.yaml';
import SCHEMA from './home-page.schema.yaml';

class HomePageFeature extends AbstractVisualFeature {
    get name() {
        return 'Home Page';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return homePageFactory(PALETTE);
    }

    get configSchema() {
        return SCHEMA;
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const configurations = ensureHierarchy(mojitoConfig, 'services.configurations');

        mergeTo(configurations, {
            TopSports: {
                eventCounter: {
                    headerTotal: this.config.showHeaderTotalEventCount,
                    headerPerSport: this.config.showEventCountPerSport,
                },
            },
            HomePage: {
                topSportCoupons: {
                    primary: {
                        coupon: {
                            view: {
                                maxNumberOfSports: this.config.maxNumberOfLiveSports,
                            },
                        },
                    },
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}
new HomePageFeature(SportsContent);
